import { createFileRoute } from '@tanstack/react-router';
import ForgotPasswordForm from '~/components/Auth/ForgotPasswordForm/ForgotPasswordForm';

export const Route = createFileRoute('/_public/reset-password')({
  component: ForgotPasswordForm,
});
